export default "__VITE_ASSET__CXnJhyih__"